import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { RewardsResourcePath } from '../lib/rewards-resource-path';
import { CompanyItemsResponse, ItemType, Provider, QueryKey } from '../types/rewards';

interface IndexArgs {
	params: {
		filters: {
			category_ids: (string | undefined)[];
			itemType?: ItemType;
			provider?: Provider;
		};
		pagination: {
			enabled: boolean;
			page_number?: number;
			page_size?: number;
		};
		view?: string;
	};
}

export const useRetrieveCompanyItems = (args: IndexArgs, enabled: boolean, useErrorBoundary: boolean) => {
	const rewardsCatalogService = useHttpClient('rcs');
	return useQuery(
		[QueryKey.CatalogsGridwall, args.params],
		() =>
			rewardsCatalogService.get<CompanyItemsResponse>(RewardsResourcePath.CatalogsGridwall, {
				params: args.params,
			}),
		{
			enabled,
			refetchOnWindowFocus: false,
			retry: false,
			select: (data) => data.data,
			useErrorBoundary,
		}
	);
};
